import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import ErrorBoundary from 'components/atoms/ErrorBoundary/ErrorBoundary';
import 'core-js';
import OktaSecurityWrapper from 'OktaSecurityWrapper';
import React from 'react';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/ie9';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './index.scss';
import './polyfills';
import store from './redux/store';

const app = (
        <ErrorBoundary>
                <Provider store={store}>
                        <OktaSecurityWrapper />
                </Provider>
        </ErrorBoundary>
)
ReactDOM.render(app, document.getElementById('root'));